import jstz from 'jstz'

export const getTimezone = (): string => {
  let tz: string
  try {
    tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  } catch(error) {
    tz = jstz.determine().name()
  }
  return tz
}
